import { addToast } from "../toasts";
import * as uuid from "uuid";

export const showToast = (toast) => async (dispatch) => {
	if (!toast.id) {
		toast.id = uuid.v4().toUpperCase();
	}

	return new Promise((resolve, reject) => {
		dispatch(addToast(toast));
		resolve(true);
	});
};
